/**
 * ************************************************
 * Time & Language Property
 * ************************************************
 */
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone.js';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/id';
import 'dayjs/locale/en';

dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault('Asia/Jakarta');

export const PASSWORD_LINK_GENERATOR = 'weddingwedding';

/**
 * ************************************************
 * Flag to to set Bride to BOY first
 * ************************************************
 */
export const IS_BOY_FIRST = true;

/**
 * ************************************************
 * Bride & Groom Info
 * ************************************************
 */
export const GIRL_NAME = 'Edwina Alyssa Matindas, S.E., M.Sc.';
export const GIRL_NAME_SHORT = 'Alyssa';
export const GIRL_FATHER_NAME = `Eduard C Matindas (Chris)`;
export const GIRL_MOTHER_NAME = `Edwina Laurita S (Rita)`;
export const GIRL_PARENT_NAME = {
  en: `The Daughter of <br/> Mr. ${GIRL_FATHER_NAME} & <br/> Mrs. ${GIRL_MOTHER_NAME}`,
  id: `Putri dari <br/> Bapak ${GIRL_FATHER_NAME} & <br/> Ibu ${GIRL_MOTHER_NAME}`,
};
// -> boy section
export const BOY_NAME = 'Reyner Budiman, S.Th., M.T.S.';
export const BOY_NAME_SHORT = 'Reyner';
export const BOY_FATHER_NAME = `Rudy Budiman (Dede)`;
export const BOY_MOTHER_NAME = `Hana Handojo (Lulu)`;
export const BOY_PARENT_NAME = {
  en: `The Son of <br/> Mr. ${BOY_FATHER_NAME} & <br/> Mrs. ${BOY_MOTHER_NAME}`,
  id: `Putra dari <br/> Bapak ${BOY_FATHER_NAME} & <br/> Ibu ${BOY_MOTHER_NAME}`,
};
// -> bride section
export const BRIDE_HASHTAG = `#ALREadYmarried`;
export const THE_BRIDE = IS_BOY_FIRST
  ? `${BOY_NAME_SHORT} & ${GIRL_NAME_SHORT}`
  : `${GIRL_NAME_SHORT} & ${BOY_NAME_SHORT}`;

/**
 * ************************************************
 * Instagram Profile Account
 * @important please put instagram id without `@`
 * ************************************************
 */
export const IG_BOY = '';
export const IG_GIRL = '';
export const IG_FILTER = ``;

/**
 * ************************************************
 * SEO Requirement
 * @important - Don't forget to update SEO IMAGE
 * ************************************************
 */
export const SEO_IMAGE = `https://ik.imagekit.io/zaanfa/reyner-alyssa/SEO_QWx7fWTe7s.jpg?updatedAt=1730962643053`;
export const SEO_URL = 'https://invitato.net/';
export const SEO_TITLE = `The Wedding of ${THE_BRIDE} by Invitato`;
export const SEO_DESCRIPTION = {
  en: `Together with joyful hearts, we re pleased to announce the beginning of this new chapter of our lives together. Please click the Website Invitation link on this message for more information details.`,
  id: `Menjadi sebuah kebahagiaan bagi kami untuk mengumumkan awal dari babak baru kehidupan kami bersama. Silakan klik tautan situs Undangan Website di bawah untuk informasi lebih lanjut:`,
};

/**
 * ************************************************
 * Time requirement for Counting Down, and
 * Remind me generator
 * @important - please convert time to Epoch time by
 * using this link https://www.epochconverter.com/
 * ************************************************
 */
export const EPOCH_START_EVENT = 1736564400;
export const EPOCH_RESEPSI_START = 1736593200;
export const EPOCH_END_EVENT = 1736600400;

/**
 * ************************************************
 * DATE REQUIREMENT
 * @important - Format date YYYY-MM-DD
 * ************************************************
 */
export const DATE_AKAD = dayjs.tz('2025-01-11');
export const DATE_RESEPSI = DATE_AKAD;

export const WEDDING_AKAD_TIME = '10.00 WIB';
export const WEDDING_AKAD_LOC_NAME = 'GKY Pantai Indah Kapuk';
export const WEDDING_AKAD_LOC_ROAD = `Jl. Pantai Indah Selatan II Blok V No. 1C, Kapuk, North Jakarta`;
export const WEDDING_AKAD_DRESSCODE = ``;
export const WEDDING_AKAD_NOTE = ``;
export const WEDDING_AKAD_FULLDATE = {
  en: dayjs(DATE_AKAD).locale('en').format('dddd, DD MMMM YYYY'),
  id: dayjs(DATE_AKAD).locale('id').format('dddd, DD MMMM YYYY'),
};

export const WEDDING_RESEPSI_TIME = '18.00 WIB';
export const WEDDING_RESEPSI_LOC_NAME = `Soehanna Hall, Energy Building`;
export const WEDDING_RESEPSI_LOC_ROAD = `SCBD Lot Jl. Jend. Sudirman Kav 52-53 No. 11A Lt. 2, South Jakarta`;
export const WEDDING_RESEPSI_DRESSCODE = ``;
export const WEDDING_RESEPSI_NOTE = ``;
export const WEDDING_RESEPSI_FULLDATE = {
  en: dayjs(DATE_RESEPSI).locale('en').format('dddd, DD MMMM YYYY'),
  id: dayjs(DATE_RESEPSI).locale('id').format('dddd, DD MMMM YYYY'),
};
export const WEDDING_RESEPSI_DATE = WEDDING_AKAD_FULLDATE;
/**
 * ********************************************************
 * Link Generator V2
 * @important - this info will be applied at link generator
 * ********************************************************
 */
export const HOSTNAME = 'https://invitato.net/ALREadYmarried/';
export const BROADCAST_WEDDING_LOCATION = `Soehanna Hall, Energy Building, South Jakarta`;
export const BROADCAST_WEDDING_DAY = {
  id: dayjs(DATE_RESEPSI).locale('id').format('dddd, DD MMMM YYYY'),
  en: dayjs(DATE_RESEPSI).locale('en').format('dddd, DD MMMM YYYY'),
};

/**
 * ************************************************
 * Maps Location
 * ************************************************
 */
export const GOOGLE_MAPS_AKAD_LINK = `https://maps.app.goo.gl/xL9assJyMnZ7vhne7`;
export const GOOGLE_MAPS_RECEPTION_LINK = `https://maps.app.goo.gl/pCydqxL17NfuM9pL7`;
export const GOOGLE_MAPS_ADDRESS = `Soehanna Hall`;

/**
 * ************************************************
 * Backsound Copyright
 * ************************************************
 */
export const SOUND_BY = `Lover by Taylor Swift | Piano + Violin | Acoustic Cover by Jade Strings`;
export const SOUND_URL = 'https://youtu.be/fKVcMAF1QHw?si=khsptOAaE0CoCree';

/**
 * ************************************************
 * Phone Number Gift Confimation
 * ************************************************
 */
export const WHATSAPP_CONFIRMATION_NUMBER = ``;

/**
 * ************************************************
 *  Youtube Live requirement
 * ************************************************
 */
export const YOUTUBE_LINK = 'https://www.youtube.com/live/bgJZHWJByFQ?si=XK385X_nHV4CVQIv';
export const YOUTUBE_EMBED = 'https://www.youtube.com/embed/bgJZHWJByFQ?si=XK385X_nHV4CVQIv';
export const YOUTUBE_PREWEDDING_EMBED = `https://www.youtube.com/embed/WEC5RezD5jU`;
export const YOUTUBE_PREWEDDING_LINK = `https://youtu.be/WEC5RezD5jU`;

/**
 * ************************************************
 *  Invitato Link Requirement
 * ************************************************
 */
export const URL_INVITATO = 'https://www.instagram.com/invitato.id/';
export const URL_IG_INVITATO = 'https://www.instagram.com/invitato.id/';
export const URL_WA_INVITATO = `https://wa.me/+628112778189?text=Hi%20Kak,%20aku%20mau%20pesan%20undangan%20online%20nih!`;
